import React from "react";
import { SButton } from "./style";

export default function Home({ children }) {
  return <SButton>{children}</SButton>;
}
